export const Blogs = [
    {
        id:1,
        name:"A hands-on workshop on Introduction to Git and GitHub",
        tags:["geeksforgeeks","github","i2it"],
        date:"29th July, 2022",
        imgSrc:"https://res.cloudinary.com/dteiwrdfu/image/upload/v1668786102/mahesh/github_wgrdy5.png",
        link:"/"
    },
    {
        id:2,
        name:"APIs 101 with POSTMAN",
        tags:["gdsc","postman","api","i2it"],
        date:"11th November, 2022",
        imgSrc:"https://res.cloudinary.com/dteiwrdfu/image/upload/v1668785913/mahesh/postman_mkviht.png",
        link:"/"
    },
    {
        id:3,
        name:"Quizzez",
        tags:["i2it_acm","quizzez"],
        date:"29th August, 2022",
        imgSrc:"https://res.cloudinary.com/dteiwrdfu/image/upload/v1668785913/mahesh/acm_hhxeni.png",
        link:"/"
    },
    {
        id:4,
        name:"Hands on workshop on basics of Python",
        tags:["cesa_i2it","python","hands-on"],
        date:"24th September, 2022",
        imgSrc:"https://res.cloudinary.com/dteiwrdfu/image/upload/v1668788005/mahesh/cesa_tmxedt.jpg",
        link:"https://www.linkedin.com/posts/yash-khairnar-5a7aaa167_i2it-python-experience-activity-6979705691506642944-1ce1?utm_source=share&utm_medium=member_desktop"
    },
    // {
    //     id:5,
    //     name:"What is Higher Order Component (HOC) in React JS?",
    //     tags:["react","reactJS","web-development"],
    //     date:"3 Feb, 2021",
    //     imgSrc:"https://codebucks.hashnode.dev/_next/image?url=https%3A%2F%2Fcdn.hashnode.com%2Fres%2Fhashnode%2Fimage%2Fupload%2Fv1625295480148%2FlyKj8bpHK.jpeg%3Fw%3D1600%26h%3D840%26fit%3Dcrop%26crop%3Dentropy%26auto%3Dcompress%2Cformat%26format%3Dwebp&w=1920&q=75",
    //     link:"/"
    // },
    // {
    //     id:6,
    //     name:"How to implement Pagination Component in React from scratch",
    //     tags:["react","css"],
    //     date:"5 Jan, 2021",
    //     imgSrc:"https://codebucks.hashnode.dev/_next/image?url=https%3A%2F%2Fcdn.hashnode.com%2Fres%2Fhashnode%2Fimage%2Fupload%2Fv1625240050668%2FGAya9b0XK.png%3Fw%3D1600%26h%3D840%26fit%3Dcrop%26crop%3Dentropy%26auto%3Dcompress%2Cformat%26format%3Dwebp&w=1920&q=75",
    //     link:"/"

    // },
   
    // {
    //     id:7,
    //     name:"What is Redux ? Simply Explained!",
    //     tags:["react","redux","javascript"],
    //     date:"16 May, 2021",
    //     imgSrc:"https://res.cloudinary.com/dteiwrdfu/image/upload/v1668786102/mahesh/github_wgrdy5.png",
    //     link:"/"
    // },
    // {
    //     id:8,
    //     name:"How to create Sidebar navigation menu in ReactJS with react router and framer-motion",
    //     tags:["react","framer-motion","styled-components"],
    //     date:"26 May, 2021",
    //     imgSrc:"",
    //     link:"/"
    // },
  
] 